import { LANG_PATTERN } from '../../constants';

export const getLangFromPathname = (pathname: string): string => {
  const langMatch = pathname.match(LANG_PATTERN);
  return langMatch ? langMatch[1] : '';
};
